<template>
  <g class="hc-stackedbar-bar">
    <stack
      v-for="rect in rects"
      :key="id + '-' + rect.id"
      :dimention="{x, y: rect.y, width, height: rect.height}"
      :color="rect.color"
      :animation="animation"
      :animationDuration="animationDuration"
      :animationOptions="animationOptions"
    />
  </g>
</template>

<script>
import { scaleOrdinal, scaleLinear } from 'd3-scale'
import Stack from './Stack'
export default {
  name: 'Bar',
  components: {
    Stack
  },
  props: {
    id: {
      type: Number,
      default: 1
    },
    x: {
      type: Number,
      default: 0
    },
    width: {
      type: Number,
      default: 0
    },
    height: {
      type: Number,
      default: 0
    },
    data: {
      type: Array,
      default () { return []}
    },
    max: {
      type: Number,
      default: 0
    },
    animation: {
      type: Boolean,
      default: true
    },
    animationDuration: {
      type: Number,
      default: 3000
    },
    animationOptions: {
      type: Object,
      default () {
        return {
          delay: 0,
          easing: 'Bounce',
          easingEdge: 'Out'
        }
      }
    },
    colorScale: {
      type: Function,
      default () {
        return scaleOrdinal()
          .range(['#f56043', '#333', '#666', '#999', '#bbb', '#faa795', '#fcc3b8'])
          .domain([0, 1, 2, 3, 4, 5, 6])
      }
    }
  },
  computed: {
    scale () {
      return scaleLinear()
        .domain([0, this.max]).nice()
        .range([0, this.height])
    },
    rects () {
      let rects = []
      let stack = this.height
      for (let i = 0; i < this.data.length; i++) {
        let height = this.scale(this.data[i].value)
        let y = stack - height
        stack = y 
        rects.push({
          y,
          height,
          color: this.colorScale(i),
          id: i + 1
        })
      }
      return rects
    }
  }
}
</script>

<style>

</style>
